export default __webpack_public_path__ + "static/media/results.83b571ea.png";